module.exports = __webpack_public_path__ + "img/banner_zhujie.aaee69be.png";